//@ts-nocheck

export const getAddOnPricePercent = (addon = {}) =>
  addon?.pricePercent ?? addon?.pricepercent ?? addon?.price_percent ?? null;

export const hasPercentagePrice = (value) =>
  value !== null && value !== undefined;

export const isPercentageBasedAddOn = (
  addon = {},
  enablePercentageBasedAddons = false
) =>
  Boolean(enablePercentageBasedAddons) &&
  hasPercentagePrice(getAddOnPricePercent(addon));

export const roundPercentageAddOnAmount = (amount) =>
  Math.round((Number(amount || 0) + Number.EPSILON) * 100) / 100;

export const calculatePercentageAddOnAmount = (
  passengerPlanPrice = 0,
  pricePercent = 0
) =>
  roundPercentageAddOnAmount(
    Number(passengerPlanPrice || 0) * (Number(pricePercent || 0) / 100)
  );

export const getPassengerPlan = (passenger = {}, bookingPlans = []) =>
  bookingPlans.find(
    (plan) =>
      Number(plan?.tripplanid) === Number(passenger?.tripplanid) ||
      Number(plan?.tripplan?.tripplanid) === Number(passenger?.tripplanid)
  ) || null;

export const getPassengerPlanPrice = (passenger = {}, bookingPlans = []) => {
  if (
    passenger?.passengerPlanPrice !== null &&
    passenger?.passengerPlanPrice !== undefined
  ) {
    return Number(passenger.passengerPlanPrice || 0);
  }

  const plan = getPassengerPlan(passenger, bookingPlans);
  return Number(plan?.tripplan?.priceperperson ?? plan?.priceperperson ?? 0);
};

export const getPassengerPlanTitle = (passenger = {}, bookingPlans = []) => {
  if (passenger?.passengerPlanTitle || passenger?.passengerPlanName) {
    return passenger.passengerPlanTitle ?? passenger.passengerPlanName;
  }

  const plan = getPassengerPlan(passenger, bookingPlans);
  return plan?.title ?? plan?.tripplan?.title ?? '';
};

export const getPassengerAddOnAmount = ({
  addon,
  passenger,
  bookingPlans = [],
  enablePercentageBasedAddons = false,
  lockedAmount = null
}) => {
  if (lockedAmount !== null && lockedAmount !== undefined) {
    return Number(lockedAmount || 0);
  }

  if (isPercentageBasedAddOn(addon, enablePercentageBasedAddons)) {
    return calculatePercentageAddOnAmount(
      getPassengerPlanPrice(passenger, bookingPlans),
      getAddOnPricePercent(addon)
    );
  }

  return Number(addon?.priceperperson ?? addon?.pricePerPerson ?? 0);
};

export const getSelectedAddOnsTotal = ({
  selectedAddOns = [],
  addons = [],
  passengers = [],
  bookingPlans = [],
  enablePercentageBasedAddons = false
}) =>
  selectedAddOns.reduce((total, selectedAddOn) => {
    const addon = addons.find(
      (a) => Number(a?.tripaddonid) === Number(selectedAddOn?.tripaddonid)
    );

    if (!addon) return total;

    return (
      total +
      (selectedAddOn?.passengerFormIds || []).reduce(
        (passengerTotal, passengerFormId) => {
          const passenger = passengers.find(
            (p) => p?.formId === passengerFormId || p?.id === passengerFormId
          );

          return (
            passengerTotal +
            getPassengerAddOnAmount({
              addon,
              passenger,
              bookingPlans,
              enablePercentageBasedAddons
            })
          );
        },
        0
      )
    );
  }, 0);

export const groupSelectedAddOnSummaryItems = ({
  selectedAddOns = [],
  addons = [],
  passengers = [],
  bookingPlans = [],
  enablePercentageBasedAddons = false,
  getPassengerLabel = (count) => `${count} passenger`
}) => {
  const grouped = [];

  selectedAddOns.forEach((selectedAddOn) => {
    const addon = addons.find(
      (a) => Number(a?.tripaddonid) === Number(selectedAddOn?.tripaddonid)
    );

    if (!addon) return;

    const isPercentage = isPercentageBasedAddOn(
      addon,
      enablePercentageBasedAddons
    );

    if (!isPercentage) {
      const passengerCount = selectedAddOn.passengerFormIds.length;
      grouped.push({
        addon,
        passengerCount,
        amount: Number(addon?.priceperperson || 0) * passengerCount
      });
      return;
    }

    const byAmount = new Map();

    selectedAddOn.passengerFormIds.forEach((passengerFormId) => {
      const passenger = passengers.find(
        (p) => p?.formId === passengerFormId || p?.id === passengerFormId
      );
      const amount = getPassengerAddOnAmount({
        addon,
        passenger,
        bookingPlans,
        enablePercentageBasedAddons
      });
      const key = String(amount);

      if (!byAmount.has(key)) {
        byAmount.set(key, {
          addon,
          passengerCount: 0,
          amount: 0,
          perPersonAmount: amount
        });
      }

      const item = byAmount.get(key);
      item.passengerCount += 1;
      item.amount += amount;
    });

    grouped.push(...Array.from(byAmount.values()));
  });

  return grouped.map((item) => ({
    ...item,
    title: `${item.addon?.title || ''} (${getPassengerLabel(
      item.passengerCount
    )})`
  }));
};
